export class ApiError extends Error {
  constructor(message: string, public readonly status: number, public readonly code: number, public readonly data: unknown = null) {
    super(message);
    this.name = 'ApiError';
  }
}
export const errorMessage = (error: unknown) => error instanceof Error ? error.message : 'Không thể tải dữ liệu. Vui lòng thử lại.';
